<template>
  <b-form-checkbox
    v-model="model"
    class="mb-4"
  >
    メールアドレスとパスワードを保存する
  </b-form-checkbox>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'login',
      attribute: 'saveEmailPass'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
